import React from "react";
import LinearGoldText from "./linear-gold-text.tsx";

const CertificationsImg = require("../images/certifications.png");

export default function Certifications({ isMobile }: { isMobile: boolean }) {
  return (
    <div style={{ width: "100%" }}>
      <LinearGoldText isMobile={isMobile} style={{ marginBottom: "15px" }}>
        Certifications
      </LinearGoldText>
      <img src={CertificationsImg} width={"100%"} alt="GamingLicense" />
    </div>
  );
}
